import { memo } from "react";

import { classNames } from "shared/lib/classNames/classNames";

import cls from "./SociometryResultDetailsQuestions.module.scss";
import { ISociometryPupilResultAnswer } from "shared/types/sociometry";

interface SociometryResultDetailsQuestionsProps {
    className?: string;
    answers: ISociometryPupilResultAnswer[];
}

export const SociometryResultDetailsQuestions = memo((props: SociometryResultDetailsQuestionsProps) => {
    const { className, answers } = props;

    return (
        <div className={classNames(cls.sociometryResultDetailsQuestions, {}, [className])}>
            <div className={cls.rowHeader}>
                <div className={cls.center}>№</div>
                <div>Вопрос</div>
                <div>Ответ</div>
            </div>
            {answers.map((answer, index) => (
                <div key={index} className={cls.row}>
                    <p className={cls.center}>{index + 1}</p>
                    <p>{answer.question}</p>
                    <div>
                        {answer.chosen.length === 0 ? (
                            <p>Никого не выбрал</p>
                        ) : (
                            answer.chosen.map((choice, choiceIndex) => <p key={choiceIndex}>{choice}</p>)
                        )}
                    </div>
                </div>
            ))}
        </div>
    );
});

SociometryResultDetailsQuestions.displayName = "SociometryResultDetailsQuestions";
